
import * as React from 'react';
import { withSelectedItems } from '../decorators/selectors';
import { connectToItemCache } from '../decorators/connectToItemCache';
import { IItemCache } from '../../models/IItemCacheObserver';
import { ActionSelector, ISelectedActionProps } from '../withAction/WithAction';

/**
 * @public
 */
export const enum SelectionVisibilityMode {
  hideWithSelection = 'hideWithSelection',
  showOnlyWithSelection = 'showOnlyOnSelection'
}

/**
 * @public
 */
export interface ISelectionVisibilityProps {
  visibilityMode: SelectionVisibilityMode;
  children?: JSX.Element | null;
}

/**
 * Component which conditionally renders its children based on the presence or not
 * of selected items in the currents Items Scope.
 * @public
 */
export const SelectionVisibility: React.ComponentType<ISelectionVisibilityProps> = withSelectedItems()(connectToItemCache((
  itemCache: IItemCache,
  props: {
    itemKeys: string[];
    visibilityMode: SelectionVisibilityMode;
    children?: JSX.Element | null;
  }
): ISelectedActionProps => {
  const {
    visibilityMode,
    children,
    itemKeys
  } = props;

  const hasSelection = itemKeys.length > 0;

  const isVisible = visibilityMode === SelectionVisibilityMode.showOnlyWithSelection ? hasSelection : !hasSelection;

  return {
    action: isVisible ? children : null
  };
})(ActionSelector));

export type IShowOnlyWithSelectionProps = Pick<ISelectionVisibilityProps, 'children'>;

/**
 * @public
 */
export const ShowOnlyWithSelection: React.ComponentType<IShowOnlyWithSelectionProps> = connectToItemCache(() => ({
  visibilityMode: SelectionVisibilityMode.showOnlyWithSelection
}))(SelectionVisibility);

export type IHideWithSelectionProps = Pick<ISelectionVisibilityProps, 'children'>;

/**
 * @public
 */
export const HideWithSelection: React.ComponentType<IHideWithSelectionProps> = connectToItemCache(() => ({
  visibilityMode: SelectionVisibilityMode.hideWithSelection
}))(SelectionVisibility);
